<template>
  <div class="athlete-card" :class="statusClass(athlete.status_id)" @click.prevent="$emit('viewAthlete', athlete.user_id)">
    <!-- 🔹 Header con nombre truncado -->
    <div class="athlete-header">
      <h4 class="athlete-name">{{ athlete.user.name }} {{ athlete.user.surname }}</h4>
      <button class="close-button" v-if="athlete.status_id === 1 && isOwnerOrganizer(user, competition) && !competition.started_at" @click.stop="modalDelete(athlete.id)">×</button>
      <div class="fees-paid" v-if="athlete.fees_paid" :title="$t('athletes.feed_paied')">
        <i class="fa-solid fa-money-check-alt"></i>
      </div>

    </div>

    <!-- 🔸 Cuerpo con imagen e info -->
    <div class="athlete-body">
      <!-- Imagen -->
      <img :src="athlete.user.img_path || defaultAvatar" alt="Athlete Image" class="athlete-image" />

      <!-- Info a la derecha -->
      <div class="athlete-info">
        <p class="athlete-status">
          <i class="fa-solid fa-check-circle"
             :class="{ 'approved': athlete.status_id === 4, 'pending': athlete.status_id !== 4 }"></i>
          {{ athlete.status.name }}
        </p>
      </div>
    </div>

    <!-- 🔻 Footer con botones -->
    <div class="athlete-footer" @click.stop>
      <button class="action-btn confirm"
              @click="modalConfirm(athlete.id)"
              v-if="athlete.status_id === 2 && isOwnerAthlete(user, athlete) && !competition.started_at">
        <i class="fa-solid fa-thumbs-up"></i>
      </button>

      <button class="action-btn reject"
              @click="modalReject(athlete.id)"
              v-if="(isOwnerAthlete(user, athlete) || isOwnerOrganizer(user, competition)) && athlete.status_id !== 1 && !competition.started_at"
              :title="$t('athletes.decline_confirmation')"
      >
        <i class="fa-solid fa-user-slash"></i>
      </button>

      <button
        class="action-btn mail"
        v-if="athlete.status_id === 1 && isOwnerOrganizer(user, competition) && !competition.started_at"
        @click="modalSendEmail(athlete.id)"
        :title="$t('athletes.send_mails_athtletes')"
      >
        <i class="fa-solid fa-mail-bulk"></i>
      </button>

            <button class="action-btn payment"
                    v-if="competitionHasFee && !athlete.fees_paid && athlete.status_id === 4 && isOwnerOrganizer(user,competition) && !competition.started_at"
                    @click="modalPayment(athlete.id)"
                    :title="$t('athletes.feed_pay')"
            >
              <i class="fa-solid fa-money-check-alt"></i>
            </button>

      <button class="action-btn approve"
              @click="modalApprove(athlete.id)"
              v-if="athlete.status_id === 3 && isOwnerOrganizer(user, competition) && !competition.started_at">
        <i class="fa-solid fa-check"></i>
      </button>
    </div>
  </div>
</template>


<script>
import { isOwnerAthlete, isOwnerOrganizer} from '@/helpers/roleUtils';
import {mapState} from "vuex";

export default {
  name: "AthleteCard",
  props: {
    athlete: {
      type: Object,
      required: true,
    },
    competition: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      defaultAvatar: require("@/assets/user.png"),
    };
  },
  computed:{
    ...mapState('user', ['user']),
    competitionHasFee() {
      const raw = Number(this.competition?.competitions_info?.fees);
      return Number.isFinite(raw) && raw > 0;
    }
  },
  methods: {
    isOwnerAthlete,
    isOwnerOrganizer,
    statusClass(status_id) {
      return {
        "status-invitation-sent": status_id === 2,
        "status-pending-approval": status_id === 3,
        "status-approved": status_id === 4,
        "status-declined": status_id === 5,
        "status-competing": status_id === 18

      };
    },
    modalDelete(id) {
      this.$emit('update-show-modal', 'deleteAthlete',id,this.$t('athletes.modal.delete_confirmation')); // 🔥 Emití solo si el usuario confirma
    },
    modalReject(id) {
      this.$emit('update-show-modal', 'rejectAthlete',id,this.$t('athletes.modal.decline_confirmation')); // 🔥 Emití solo si el usuario confirma
    },
    modalConfirm(id) {
      this.$emit('update-show-modal', 'confirmAthlete',id,this.$t('athletes.modal.confirm_confirmation')); // 🔥 Emití solo si el usuario confirma
    },
    modalPayment(id) {
      this.$emit('update-show-modal', 'confirmPayment',id,this.$t('athletes.modal.payment_confirmation')); // 🔥 Emití solo si el usuario confirma
    },
    modalApprove(id) {
      this.$emit('update-show-modal', 'approveAthlete',id,this.$t('athletes.modal.approve_confirmation')); // 🔥 Emití solo si el usuario confirma
    },
    modalSendEmail(id) {
      this.$emit('update-show-modal', 'sendEmailAthlete', id, this.$t('athletes.modal.send_invitation_confirmation'));
    },
    // Permitir que el padre abra el modal de orden con un ref (no usado aquí pero útil para consistencia)
    openOrderModalExternal() {
      // noop placeholder; kept for symmetry if needed
    }
  }
};
</script>

<style scoped>
.athlete-card {
  background-color: white;
  border-radius: 10px;
  padding: 0;
  overflow: hidden;
  margin-bottom: 16px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: box-shadow 0.3s ease;
  cursor: pointer;
}

.athlete-card:hover {
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.1);
}

/* 🔹 Header */
.athlete-header {
  position: relative;
  background-color: #f7f7f7;
  padding: 10px 40px; /* espacio para la X */
  text-align: center;
  border-bottom: 1px solid #ddd;
  display: flex;
  align-items: center;
  justify-content: center;
}

.athlete-name {
  font-size: 16px;
  font-weight: 600;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.close-button {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  font-size: 1.5em;
  color: #c00;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  font-weight: bold;
  transition: color 0.2s ease;
}
.fees-paid {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  font-size: 1.5em;
  color: rgba(101, 175, 76, 0.89);
  padding: 0;
  line-height: 1;
  font-weight: bold;
  transition: color 0.2s ease;
}

.close-button:hover {
  color: #900;
}
/* 🔸 Cuerpo con imagen e info */
.athlete-body {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
}

.athlete-image {
  width: 65px;
  height: 65px;
  border-radius: 50%;
  object-fit: cover;
}

.athlete-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.athlete-status {
  font-size: 14px;
  margin: 4px 0;
  display: flex;
  align-items: center;
  gap: 6px;
}

/* 🔻 Footer con acciones */
.athlete-footer {
  border-top: 1px solid #eee;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding:0;
}

.action-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  padding: 6px;
  transition: opacity 0.2s ease;
}

.action-btn.confirm { color: #28a745; }
.action-btn.reject { color: #dc3545; }
.action-btn.mail { color: #c08b2f; }
.action-btn.payment { color: #ffc107; }
.action-btn.approve { color: #007bff; }

.action-btn:hover {
  opacity: 0.75;
}

/* 🔸 Status con sombra */
.status-invitation-sent    { box-shadow: 0 0 3px 1px rgba(76, 86, 175, 0.5); }
.status-pending-approval   { box-shadow: 0 0 3px 1px rgba(77, 222, 255, 0.5); }
.status-approved           { box-shadow: 0 0 3px 1px rgba(101, 175, 76, 0.45); }
.status-declined           { box-shadow: 0 0 3px 1px rgba(125, 80, 189, 0.4); }
.status-competing          { box-shadow: 0 0 3px 1px rgba(162, 162, 162, 0.5); }

@media (max-width: 576px) {
  .athlete-body {
    display: flex;
    flex-direction: column; /* ⬅️ Cambiamos a columna */
    align-items: center;     /* ⬅️ Centramos en horizontal */
    gap: 8px;
    padding: 12px;
    text-align: center;      /* Asegura que el texto también esté centrado */
  }

  .athlete-image {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    object-fit: cover;
  }

  .athlete-info {
    display: flex;
    flex-direction: column;
    align-items: center;     /* ⬅️ Centramos el contenido */
    justify-content: center;
  }

  .athlete-status {
    font-size: 14px;
    margin-top: 4px;
  }
}

</style>
